import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import ProgressBar from "./ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { getLandingClient } from "../Actions/landingClientAction"; 
import $ from "jquery";


const CandidateTabClient = ({ activeTab }) => {
  //alert('ui1');
  const [details, setDetails] = useState([]);
  const [checkLength, setCheckLength] = useState();
  const [personalStatus, setPersonalStatus] = useState(0);
  const [personalCompleted,setPeronalComplete]=useState(0);
  const [authComplete,setAuthComplete]=useState(0);
  const storeLandingClientData = useSelector((state) => state.landingClient);

  const dispatch = useDispatch();
  const { landingClientData, loadingData, errorData } = storeLandingClientData;

  useEffect(() => {
    if (typeof landingClientData?.data !== "undefined" && landingClientData?.data !== null) {
    
      setAuthComplete(landingClientData.data.authrize_complete);
      setPersonalStatus(landingClientData.data);
      setPeronalComplete(landingClientData.data.personal_completed);
      setDetails(landingClientData.data.totalGroupsOfChecks);
      setCheckLength(Object.keys(landingClientData.data.totalGroupsOfChecks).length + 1);
    }
  }, [landingClientData, storeLandingClientData]);

  useEffect(() => {
    const pageData = async () => {
      dispatch(getLandingClient());
    };

    pageData();
  }, []);

  const ref = useRef(null);

  const [reference, setReference] = useState();

  useEffect(() => {
    let list = JSON.parse(localStorage.getItem("autoLogin"));
    setReference(list?.data?.reference_number);
  }, []);

  let Complete = 0,
    personalComplete = 0;
  if (personalStatus.personal_completed == "1") {
    Complete++;
    personalComplete = 1;
  }
  //if(personalStatus)
  // Object.entries(details).map((value, index) => {
  //   let cardClass="";
  //   let Cname="";
  //   if(value[1].completed=="true"){
  //   Complete++;
  //   }
  // }

  useEffect(() => {
    let link = ref?.current?.querySelector(".active");
    if (link) {
      link.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "end",
      });
    }
  }, [checkLength]);

  const test = () => {
    let nav = $("nav");
    if (nav) {
      let navLinks = document.querySelectorAll("nav a");
      let navLinkActive = document.querySelector(".active");
      navLinkActive.scrollIntoView({ behavior: "smooth", inline: "center" });
    }
  };

  //debugger
  console.log(authComplete ,personalCompleted);
  return (
    <>
      {Object.entries(details).map((value, index) => {
        if (value[1].completed == "1") {
          Complete++;
        }
      })}

      { (authComplete==1 && personalCompleted == 0) ? 
         <ProgressBar percent="50" />:""}
         
         { (authComplete==1 && personalCompleted==1) ? 
         <ProgressBar percent="100" />:""}
     
     {(authComplete==0 && personalCompleted == 0) ? <>{Math.round((Complete / checkLength) * 100).toFixed(2) == "NaN" ? (
        <ProgressBar percent="" />
      ) : Math.round((Complete / checkLength) * 100).toFixed(2) == "0.00" ? (
        <ProgressBar
          percent={Math.round((Complete / checkLength) * 100).toFixed(0)}
        />
      ) : (
        <ProgressBar
          percent={Math.round((Complete / checkLength) * 100).toFixed(0)}
        />
      )}</>:""}

      {/* <ProgressBar percent={Math.round(Complete/checkLength*100).toFixed(2)} /> */}
      <div className="clearfix"></div>

      {/* <nav>
        <div
          className="nav nav-tabs flex-column"
          id="nav-tab"
          role="tablist"
        >
          <Link
            className={
              activeTab === "personal"
                ? "nav-item nav-link fnt-smi-bld active"
                : "nav-item nav-link fnt-smi-bld "
            }
            id="nav-personal-details-tab"
            to={`/case-initiation/check-detail/${reference}/profile`}
            
          >
            <span className="icon personal-details-icon"></span>
            <span className="title">Personal Details</span>
          </Link>
          
          <Link
            className={
              activeTab === "education"
                ? "nav-item nav-link fnt-smi-bld active"
                : "nav-item nav-link fnt-smi-bld "
            }
            id="nav-education-tab"
            to={`/case-initiation/check-detail/${reference}/3`}
          >
            <span className="icon education-icon"></span>
            <span className="title">Education</span>
          </Link>

          <Link
            className={
              activeTab === "professionalLicenceCheck"
                ? "nav-item nav-link fnt-smi-bld active"
                : "nav-item nav-link fnt-smi-bld "
            }
            id="nav-scotland-discloser-tab"
            to="/candidate-form/professional-licence-check"
          >
            <span className="icon onboarding-icon"></span>
            <span className="title">Professional Licence Check</span>
          </Link>
        </div>
      </nav> */}

      <nav id="nav" ref={ref} className="main-menu">
        <div className="nav nav-tabs flex-column" id="nav-tab" role="tablist">
          {/* <Link
            className={
              activeTab === "personal"
                ? "nav-item nav-link fnt-smi-bld justify-content-between active"
                : "nav-item nav-link fnt-smi-bld justify-content-between"
            }
            id="nav-personal-reference-tab"
            to={`/case-initiation/check-detail/${reference}/profile`}
          >
            {activeTab === "personal" && <span className="tab-count">1</span>}
            <span>
              <span className="icon fas fa-user"></span>
              <span className="title">Personal Details</span>
            </span>
            {personalComplete == 1 ? (
              <span>
                <i class="fas fa-check ml-2" style={{ color: "#12B76A" }}></i>
              </span>
            ) : (
              ""
            )}
          </Link> */}
          {Object.entries(details).map((value, index) => {
            let cardClass = "";
            let Cname = "";
            let completeStatus = 0;
            if (value[1].completed == "1") {
              Complete++;
            }
            if (value[1].name == "National Identity Check") {
              cardClass = "nav-employment-tab";
              Cname = "icon fa-solid fa-shield-halved";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "2") {
              cardClass = "nav-address-tab";
              Cname = "icon fas fa-map-location-dot";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "eaadhar") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-address-card";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "nid") {
              cardClass = "nav-employment-tab";
              Cname = "icon fa-solid fa-shield-halved";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "3") {
              cardClass = "nav-education-tab";
              Cname = "icon fas fa-book";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "4") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-briefcase";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "6") {
              cardClass = "nav-personal-reference-tab";
              Cname = "icon fas fa-thumbs-up";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "7") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-user-shield";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "10") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-vial-circle-check";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "12") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-file-contract";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "15") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-user-shield";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "8") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-landmark";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "18") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-map-location-dot";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "5") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-thumbs-up";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "9") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-rectangle-list";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "14") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-clipboard-check";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "13") {
              cardClass = "nav-employment-tab";
              Cname = "icon fas fa-staff-snake";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            } else if (value[1].group_id == "30") {
              cardClass = "nav-employment-tab";
              Cname = "icon fa-solid fa-location-dot";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            }  else if (value[1].name == "Personal Details") {
              //cardClass = "nav-employment-tab";
              Cname = "icon fas fa-user";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            }
            else if (value[1].name == "Authorization") {
              //cardClass = "nav-employment-tab";
              Cname = "icon fas fa-feather";
              if (value[1].completed == "1") {
                completeStatus = 1;
              }
            }

            let link = `/case-initiation/check-detail/${reference}/${value[1].group_id}`;

            if(value[1].name === 'Authorization'){

              link = `/candidate-form/authorization`;
            }else if(value[1].name  === 'Personal Details'){
              link = `/case-initiation/check-detail/${reference}/candidate-profile`;
            }

       
            let name = value[1].name;
            return (
              <>
              {name == "Authorization" && authComplete == 1 ?
                // <span>
                //   <span className={Cname}></span>
                //   <span className="title">{name}</span>
                // </span>
                <Link
                className={
                  activeTab === name
                    ? "nav-item nav-link fnt-smi-bld justify-content-between active "
                    : "nav-item nav-link fnt-smi-bld justify-content-between"
                }
                id={cardClass}
               to={'#'}
              >
                {activeTab === name && (
                  <span class="tab-count">{index + 2}</span>
                )}
                <span>
                  <span className={Cname}></span>
                  <span className="title">{name}</span>
                </span>
              
                  <span>
                    <i
                      class="fas fa-check ml-2"
                      style={{ color: "#12B76A" }}
                    ></i>
                  </span>
  
              </Link>
              
                :
              <Link
                className={
                  activeTab === name
                    ? "nav-item nav-link fnt-smi-bld justify-content-between active "
                    : "nav-item nav-link fnt-smi-bld justify-content-between"
                }
                id={cardClass}
                to={link}
              >
                {activeTab === name && (
                  <span class="tab-count">{index + 2}</span>
                )}
                <span>
                  <span className={Cname}></span>
                  <span className="title">{name}</span>
                </span>
                {completeStatus == 1 ? (
                  <span>
                    <i
                      class="fas fa-check ml-2"
                      style={{ color: "#12B76A" }}
                    ></i>
                  </span>
                ) : (
                  ""
                )}
              </Link>
              }
              </>
            );
          })}
          {console.log(Complete)}
        </div>
      </nav>
    </>
  );
};

export default CandidateTabClient;
